import React from 'react';
import { createChatBotMessage } from 'react-chatbot-kit-extension';
//import MarkupMessage from './MarkupMessage';
//import MarkdownMessage from './MarkdownMessage';
import CustomBotAvatar from './CustomBotAvatar';
import { LoadingView } from '../LoadingView';
import BotText from './BotText';

const config = {
    initialMessages: [createChatBotMessage("I'm Key, Doctivity's AI Assistant. How can I help?", { loading:false })],
    botName: 'DocBot',

    customComponents: {
        //header: (...props) => <div style={{display: 'grid', gridTemplateColumns: '80% 10% 10%' }}>
        //<div style={{backgroundColor: '#00A887', textAlign: 'left', padding: '12px', color: 'white'}}>Actionable Insights</div>
        // <div style={{backgroundColor: '#00A887', float: 'right', padding: '10px', color: 'white'}}><AspectRatioIcon /></div>
        // <div style={{backgroundColor: '#00A887', float: 'right', padding: '10px', color: 'white'}}><ExpandMoreIcon 
        // onClick={() => {debugger;console.info(props);{props.onClose}}} /></div></div>,        
        botAvatar: (props) => <CustomBotAvatar {...props} />,
        botChHatMessage : (props) => <BotText {...props} />,
    },
    widgets: [
      {      
          widgetName: 'customLoadingView',
        widgetFunc: (props) => <LoadingView
        label='Key is thinking…'
         {...props} />,
          mapStateToProps: [],
        },
//        {
  //          widgetName: 'markupMessage',
    //        widgetFunc: (props) => <MarkupMessage {...props} />,
      //  },
        //{
          //  widgetName: 'markdownMessage',
            //widgetFunc: (props) => <MarkdownMessage {...props} />,
        //},        
    ],
    //customStyles: {
      //  botMessageBox: {
        //    backgroundColor: '#00A887',
        //},
        //chatButton: {
          //  backgroundColor: '#00A887',
        //}
    //}
};

export default config;

